import styled from 'styled-components';
import breakpoints from '@/theme/constants/breakpoints';
import {bootstrapContainerStyles} from '@/theme/constants/container';

export const StyledMobileOnSaleContainer = styled.div`
  ${bootstrapContainerStyles}

  @media only screen and ${breakpoints.device.m} {
    display: none;
  }
`;
